import React from 'react'

export default class Base extends React.Component {
  state = {
    siteGuid: this.props.site.guid,
    articles: [],
    isLoading: true
  }

  componentWillMount() {
    this.loadArticles()
  }

  // 加载文章列表
  loadArticles = () => {
    const customize = this.props.customize || {}
    $.getJSON(`/api/v1/site/articles`, {
      site: this.state.siteGuid,
      collection: customize.collection || 'all',
      per: customize.per || 10
    }, (response) => {
      this.setState({isLoading: false, articles: response.articles})
    })
  }

  render() {
    return (
      <div>
        {
          !this.state.isLoading && this.state.articles.length === 0 &&
          <div className="empty-state-wrap"><span>暂无数据</span></div>
        }

        {
          this.state.isLoading &&
          <div className="is-loading-wrap"><span>正在加载数据...</span></div>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/collection/articles/base.js